import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const EarthIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M3 12H21M12 3C14.5013 5.73835 15.9228 9.29203 16 13C15.9228 16.708 14.5013 20.2616 12 23M12 3C9.49872 5.73835 8.07725 9.29203 8 13C8.07725 16.708 9.49872 20.2616 12 23"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

EarthIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(EarthIcon);
